module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/Cookie-1cd24c556d1a2b7b82996a68599cf444.svg";